import Vue from "vue";
import axios from "axios";
import Vuex from "vuex";
import VuexORM from "@vuex-orm/core";
import VuexORMAxios from "@vuex-orm/plugin-axios";

import VueJwtDecode from "vue-jwt-decode";
import APILinks from "@/links/links.js";

const token = localStorage.getItem("token");
if (token) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
}

// NOTE: check expired token functionality | use refresh token
axios.interceptors.request.use(
  async config => {
    // console.log("axios request interceptor config", config);
    if (localStorage.getItem("token") && config.url !== APILinks.TOKEN_REFRESH()) {
      const token = localStorage.getItem("token");
      const jwtDecoded = VueJwtDecode.decode(token);
      // get current time in ms ... jwt token format
      const currentTime = new Date().valueOf() / 1000;
      // if current time is bigger than jwt token expiration date, execute refresh token
      const expirationDateOneMinuteBefore = jwtDecoded.exp - 60;
      if (currentTime >= expirationDateOneMinuteBefore) {
        // wait for this action to end, then go further
        await store.dispatch("auth/tokenRefresh").catch(err => {
          console.error(err);
        });
        // set Authorization in headers equal to the new token value
        config.headers.Authorization = "Bearer " + localStorage.getItem("token");
      }
    }
    return config;
  },
  err => {
    console.log("axios request interceptor error", err);
    return Promise.reject(err);
  }
);

import state from "./vuex/state.js";
import getters from "./vuex/getters.js";
import mutations from "./vuex/mutations.js";
import actions from "./vuex/actions.js";

import auth from "./vuex/modules/auth.js";
import countries from "./vuex/modules/countries";

import database from "./orm-axios/database.js";
Vue.use(Vuex);

VuexORM.use(VuexORMAxios, { axios });

const store = new Vuex.Store({
  plugins: [VuexORM.install(database)],
  state,
  getters,
  mutations,
  actions,
  modules: {
    auth,
    countries
  },
});

export default store;
